// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

import TextInput from '../../../ui/components/Inputs/TextInput';
import { deleteAccount, setForm } from '../../../actions';
import {
    MY_ACCOUNT_FORM,
    CONFIRM_GDPR_DELETE_FORM,
} from '../../../constants/forms';
import i18n from '../../../i18n/i18n.js';

type Props = {
    branding: {
        paywall_buttons_bg_color: string,
        paywall_buttons_text_color: string,
    },
    deleteAccount: Function,
    setForm: Function,
};

export class DeleteAccount extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };
    }

    deleteAccount = () => {
        this.props.setForm(CONFIRM_GDPR_DELETE_FORM);
    };

    back = () => {
        this.props.setForm(MY_ACCOUNT_FORM);
    };

    render() {
        // button
        let backgroundButtonColor = this.props.branding.paywall_buttons_bg_color
            ? this.props.branding.paywall_buttons_bg_color
            : '#00aae6';

        let lng = this.props.language;

        return (
            <Fragment>
                <section id="ipx-maincontent" className="gdpr-text">
                    <h2>{i18n.t('delete_question', { lng })}</h2>
                    <div className="gdpr-inside delete">
                        <p>
                            {i18n.t('first_delete', { lng })}
                            <br />
                            <br />- {i18n.t('second_delete', { lng })} <br />-{' '}
                            {i18n.t('third_delete', { lng })} <br />-{' '}
                            {i18n.t('fourth_delete', { lng })} <br />
                            <br /> {i18n.t('fifth_delete', { lng })}
                            <br />
                            <br />
                            {i18n.t('sixth_delete', { lng })}
                            <br />
                            <br />
                            {i18n.t('seventh_delete', { lng })}
                        </p>
                    </div>
                    <div className="gdpr-border">
                        <div className="buttonholder buttonholder-gdpr">
                            <a href="#" onClick={this.back} className="back">
                                &lang; {i18n.t('modal_back', { lng })}
                            </a>
                            <button
                                onClick={this.deleteAccount}
                                style={{
                                    backgroundColor: backgroundButtonColor,
                                    color: '#fff',
                                    border: `solid 1px ${backgroundButtonColor}`,
                                }}
                            >
                                <span className="buttonlabel" />
                                {i18n.t('delete', { lng })}
                            </button>
                        </div>
                    </div>
                </section>
            </Fragment>
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        branding: state.branding,
        language: state.auth.language,
    };
};

export default connect(
    mapStateToProps,
    {
        deleteAccount,
        setForm,
    }
)(DeleteAccount);



// WEBPACK FOOTER //
// ./src/containers/Forms/GDPR/DeleteAccount.js